import React from 'react';
import { Adaptive, Typography } from 'fronton-react';
import { ArrowRightIcon } from '@fronton/icons-react';
import { cardImage, cardInfoContainer } from './card-b-styles';

type TProps = {
  imageSrc: string;
  imageAlt: string;
  title: string;
}

export const CardB: React.FC<TProps> = ({ imageAlt, imageSrc, title }) => (
  <div>
    <img alt={imageAlt} className={cardImage} src={imageSrc} />
    <div className={cardInfoContainer}>
      <Adaptive from="desktop">
        <Typography variant="h2">{title}</Typography>
        <ArrowRightIcon type="outline" size="xl" color="text-primary"/>
      </Adaptive>
      <Adaptive to="desktop">
        <Typography variant="mini" size="overline">{title}</Typography>
        <ArrowRightIcon type="outline" size="s" color="text-primary"/>
      </Adaptive>
    </div>
  </div>
);
